import { Card, Col, Media, Modal, ModalBody, Row } from "reactstrap";
import styles from "./newsCard.module.scss";
// import Pdf from "../../assets/images/icons/pdf.png";
import Pdf from "../../../assets/images/icons/pdf.png";
import Video from "../../../assets/images/icons/video.jpg";
import FileViewer from "../../template/file-viewer/FileViewer";
import { useState } from "react";
import { toast } from "react-toastify";
import ReactPlayer from "react-player";
import ImageGallery from "react-image-gallery";
import { translate } from "react-switch-lang";
import { StatisticMediaDto } from "../../../models/statisticMediaDto";
import { ACTION } from "../../../models/action";
import { useHttpClient } from "../../../security/hooks/axiosProvider";
import { RootState } from "../../../store";
import { useSelector } from "react-redux";
import hasRoles from "../../../security/hasRoles";
import keycloak from "../../../security/keycloak-config";

// TODO ADD DTO FRONT
const NewsCard: React.FC<{ t: (key: string) => {}; data: any; index: number }> = ({ data, index, t }) => {
  const hasRoleAdmin = hasRoles(["ROLE_MEDIATHEQUE_ADMIN"], keycloak);
  const httpClient = useHttpClient(false);
  toast.configure();
  const [openModalViewer, setOpenModalViewer] = useState<boolean>(false);
  const [openModalVideo, setOpenModalVideo] = useState<boolean>(false);
  const [openImageViewer, setOpenImageViewer] = useState<boolean>(false);
  const selectedLanguage = useSelector((state: RootState) => state.language.currentLang);

  const handleClickImage = () => {
    if (+data.typeCategory === 0) {
      setOpenModalViewer(!openModalViewer);
    } else if (+data.typeCategory === 1) {
      setOpenModalVideo(!openModalVideo);
    } else {
      setOpenImageViewer(!openImageViewer);
    }
  };

  const handleClickOpenModalViewer = (): void => {
    setOpenModalViewer(!openModalViewer);
  };

  const handleClickOpenModalVideo = (): void => {
    setOpenModalVideo(!openModalVideo);
  };

  const handleClickOpenImageViewer = (): void => {
    setOpenImageViewer(!openImageViewer);
  };

  const handleDownloadDocument = (data: any) => {
    if (!hasRoleAdmin) {
      let statisticMediaDto = new StatisticMediaDto();
      statisticMediaDto.categoryId = data.categoryId;
      statisticMediaDto.typeCategory = "0";
      statisticMediaDto.mediaId = data.supportId;
      statisticMediaDto.action = ACTION.DOWNLOAD;
      httpClient.current?.post("statistic_media", statisticMediaDto).then(response => {});
    }
  };

  const handleCountView = (data: any) => {
    if (!hasRoleAdmin) {
      let statisticMediaDto = new StatisticMediaDto();
      statisticMediaDto.categoryId = data.categoryId;
      statisticMediaDto.typeCategory = data.typeCategory;
      statisticMediaDto.mediaId = data.supportId;
      statisticMediaDto.action = ACTION.VIEW;
      httpClient.current?.post("statistic_media", statisticMediaDto).then(response => {});
    }
  };
  return (
    <>
      <Card className="">
        <Row className="blog-box blog-list">
          <Col className="text-center" sm="5">
            <div className="blog-box blog-grid text-center product-box">
              <div className="product-img">
                {data.urlImage ? (
                  +data.typeCategory === 1 ? (
                    <Media className={styles["news-image"] + " img-fluid sm-100-w p-0"} src={data.urlImage + "/preview"} alt="" />
                  ) : (
                    <Media className={styles["news-image"] + " img-fluid sm-100-w p-0"} src={data.urlImage} alt="" />
                  )
                ) : +data.typeCategory === 1 ? (
                  <Media className="img-fluid sm-100-w p-0" src={Video} alt="" />
                ) : (
                  <Media className={styles["img-pdf"] + " img-100 sm-100-w p-0"} src={Pdf} alt="" />
                )}
                <div className="product-hover">
                  <ul>
                    <li
                      onClick={() => {
                        handleCountView(data);
                        handleClickImage();
                      }}
                      style={{ width: "auto" }}
                    >
                      <i className="icon-eye">{hasRoleAdmin && <span className="m-l-5">{data.numberView}</span>}</i>
                    </li>
                    {data.download && (
                      <li style={{ width: "auto" }}>
                        <a
                          onClick={() => {
                            handleDownloadDocument(data);
                          }}
                          href={data.urlSupport + "/download"}
                        >
                          <i className="icon-import m-r-5"> {hasRoleAdmin && data.numberDownload}</i>
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </Col>
          <Col sm="7">
            <div className="blog-details p-t-10">
              <h6 title={data.title}>{selectedLanguage === "en" ? data.titleEn : data.title}</h6>
              <hr />
              <div className={styles["section-details-news"] + " blog-bottom-content"}>
                <ul className="blog-social">
                  <li>
                    <i className={styles["icon-timer"] + " icofont icofont-ui-timer"}></i> {data.dateSupport}
                  </li>
                  <li className="digits">
                    <i className={styles["icon-flad"] + " fa fa-flag-o"}></i> {selectedLanguage === "en" ? data?.listCountry[0]?.titleAnglais : data?.listCountry[0]?.titleFrancais}
                  </li>
                </ul>
                <span className={styles["view-type"]}>
                  <i className={styles["icon-flad"] + " fa fa-tag m-r-10 m-t-10 " + styles["fa-tags"]}></i>
                  {+data.typeCategory === 0 ? t("category.label_bibliotheque") : +data.typeCategory === 1 ? t("category.label_videotheque") : t("category.label_exhibit")}
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Card>

      <Modal isOpen={openModalViewer} className={styles["modal-wrapper"]} toggle={() => handleClickOpenModalViewer()} size="xl">
        <ModalBody>
          <FileViewer src={data.urlSupport} width={"100%"} height={window.outerWidth > 600 ? "580" : "470"} />
        </ModalBody>
      </Modal>

      <Modal className={styles["modal-wrapper"]} isOpen={openModalVideo} toggle={() => handleClickOpenModalVideo()} size="xl">
        <ModalBody>
          <ReactPlayer
            url={data.urlSupport}
            width="100%"
            height="82vh"
            onError={() => {
              toast.error(t("message_toastr_inaccessible_video"), {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 5000,
              });
            }}
            playing={data.urlSupport ? true : false}
            controls={true}
            light={data.urlImage ? data.urlImage + "/preview" : false}
          />
        </ModalBody>
      </Modal>
      <Modal className={styles["modal-wrapper"]} isOpen={openImageViewer} toggle={() => handleClickOpenImageViewer()} size="lg">
        <ModalBody>
          <ImageGallery
            items={data.listExpositionImage?.map((image: any) => {
              return { original: image.urlImage, thumbnail: image.urlImage };
            })}
            thumbnailPosition={"bottom"}
            showBullets={true}
            showPlayButton={true}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(NewsCard);
